<template>
  <li
    class="zk-dropdown-menu__item"
    :class="{
      'is-disabled': disabled,
      'zk-dropdown-menu__item--divided': divided
    }"
    @click="handleClick"
  >
    <slot></slot>
  </li>
</template>
<script>
  import Emitter from 'theme/mixins/emitter';

  export default {
    name: 'ZkDropdownItem',

    mixins: [Emitter],

    props: {
      command: String,
      disabled: Boolean,
      divided: Boolean
    },

    methods: {
      handleClick(e) {
        this.dispatch('ZkDropdown', 'menu-item-click', [this.command, this]);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// dropdown-item.vue?d99c1b6c